import {Injectable} from '@angular/core';
import {webapi} from '../../shared/my-constants';
import {Headers, Http} from '@angular/http';

@Injectable()
export class AdvanceService {
    tipdAdvanceAmount: any;
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'tipd_advanced_amount/list/?';
    private ListpatientRecord = webapi + 'tipd_advanced_amount/listbypatient/?';
    private ListadmissionRecord = webapi + 'tipd_advanced_amount/listbyadmission';
    private ListopdpatientRecord = webapi + 'tipd_advanced_amount/listbyopdpatient/?';
    private AddRecord = webapi + 'tipd_advanced_amount/create';
    private EditRecord = webapi + 'tipd_advanced_amount/update';
    private updateRecord = webapi + 'tipd_advanced_amount/updateadvancedhistory/';
    private GetRecord = webapi + 'tipd_advanced_amount/byid/';
    private GetRecordAdvanceRefunHistory = webapi + 'tipd_advanced_amount/searchByAdvanceRefundHistory/';
    private DeleteRecord = webapi + 'tipd_advanced_amount/delete/';
    private SearchRecord = webapi + 'tipd_advanced_amount/searchpatient/?';
    private GetRecordByPatient = webapi + 'tipd_advanced_amount/getbypatient/';
    private GetRecordByDate = webapi + 'tipd_advanced_amount/getbydate/?';
    private GetAdvancedAmountDetail = webapi + 'tipd_advanced_amount/searchByAdvancePaymentId/';
    private RefundAdvance = webapi + 'tipd_advanced_amount/refund_advance/';

    constructor(private http: Http) { }

    getAdvancedPaymentDetail(advancedId: any): Promise<any> {
        return this.http.get(this.GetAdvancedAmountDetail + advancedId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&aaUnitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPatientRecordService(currentPage: any, size: any, qString: any, sort: any, col: any, patientId: any, unitId: any): Promise<any> {
        // return this.http.get(this.ListpatientRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col + '&patientId=' + patientId)
        return this.http.get(this.ListpatientRecord + '&patientId=' + patientId + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    /*(model: any): Promise<any> {
      return this.http.get(this.ListadmissionRecord, JSON.stringify(model), { headers: this.headers })
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
    }*/
    getRecordwithadmission(model: any) {
        return this.http.put(this.ListadmissionRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getopdPatientRecordService(currentPage: any, size: any, qString: any, sort: any, col: any, MrNo: any): Promise<any> {
        return this.http.get(this.ListopdpatientRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col + '&MrNo=' + MrNo)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    searchRecordPatient(qString: any) {
        return this.http.get(this.SearchRecord + 'qString=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        // console.log(JSON.stringify(model));
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    refundAdvanceAmount(model: any, refundAmount: any) {
        return this.http.put(this.RefundAdvance + refundAmount, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    updateRecordService(model: any, id) {
        return this.http.put(this.updateRecord + id, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordRefundHistoryService(id: any) {
        return this.http.get(this.GetRecordAdvanceRefunHistory + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordByPatient(id: Number) {
        return this.http.get(this.GetRecordByPatient + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordByDate(currentPage: any, size: any, fromdate: any, todate: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.GetRecordByDate + 'page=' + currentPage + '&size=' + size + '&fromdate=' + fromdate + '&todate=' + todate + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/billing/advance/advance.service.ts